const productMapping = {
  stdCheckout: {
    docs: 'https://developer.paypal.com/docs/checkout/standard/',
    builder: 'https://developer.paypal.com/studio/checkout/standard/integrate',
    tutorial: 'https://www.youtube.com/watch?v=MBfJEUGNNs0',
  },
  advCheckout: {
    docs: 'https://developer.paypal.com/docs/checkout/advanced/',
    builder: 'https://developer.paypal.com/studio/checkout/advanced/integrate',
    tutorial: 'https://www.youtube.com/watch?v=pHbeILqVjOk',
  },
  subscriptions: {
    docs: 'https://developer.paypal.com/docs/subscriptions/',
    builder: 'https://developer.paypal.com/integration-builder',
  },
  invoicing: {
    docs: 'https://developer.paypal.com/docs/invoicing/#home',
    apex:
      'https://www.paypal.com/apex/product-profile/invoicing_v2/getAccessToken',
  },
  stdPayouts: {
    docs: 'https://developer.paypal.com/docs/payouts/standard/',
    apex: 'https://www.paypal.com/apex/product-profile/payouts/getAccessToken',
  },
  batchPayouts: {
    docs: 'https://developer.paypal.com/docs/payouts/standard/large-batch/',
  },
  webPayouts: {
    docs: 'https://developer.paypal.com/docs/payouts/standard/payouts-web/',
  },
  mpOnboardSellers: {
    docs: 'https://developer.paypal.com/docs/multiparty/seller-onboarding/',
  },
  mpAcceptPayments: {
    docs: 'https://developer.paypal.com/docs/multiparty/accept-payments/',
  },
  mpIssueRefunds: {
    docs: 'https://developer.paypal.com/docs/multiparty/issue-refund/',
    postman: 'https://www.getpostman.com/collections/effdfae215bb11529926',
  },
}

export default productMapping
